import { defineStore } from 'pinia';

export const useMainStore = defineStore({
  id: 'main-store',
  state: () => {
    return {
      track: {
        isHover: true,
        type: 'default',
      },
      mousePosition: {
        x: 0,
        y: 0,
      },  
      touch: {
        start: false,
        move: false,
      },
      floatingThumbnail: {
        url: null,
        x: null,
        y: null,
      },
      preloaded: false,
    };
  },
  actions: {
    toggleTrackingMouse (payload) {
      this.track = payload;
    },
    toggleTouchEvent (payload) {
      this.touch = payload;
    },
    setFloatingThumbnail (payload) {
      this.floatingThumbnail = payload;
    },
    setPreload (payload) {
      this.preloaded = payload;
    },
    updateMousePosition (payload) {
      this.mousePosition = payload;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAdminMessageStore, import.meta.hot));
}
